import { RouterLink } from '@angular/router';
import { Component, ChangeDetectionStrategy, signal } from '@angular/core';

import { ArticleSummary } from '@models/article';
import { FormComponent } from '@classes/form';
import { Video } from '@models/video';
import { AssetFormatterPipe } from '@pipes/asset-formatter-pipe';

@Component({
  selector: 'app-video-list',
  imports: [RouterLink, AssetFormatterPipe],
  templateUrl: './video-list.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './video-list.scss',
})
export class VideoList extends FormComponent {
  override data = signal<Video[]>([]);

  ngOnInit(): void {
    this.loadEndpoint = `api/videos`;

    this.load();
  }

  override onLoadSuccess(response: any): void {
    this.data.set(response.data);

    super.onLoadSuccess(response);
  }
}
